.bb{right:0px;}